import React from 'react';
import {Link} from "react-router-dom";
import './BreadCrumbsItems.sass'

function BreadCrumbsItems(props) {

    return (
        <div style={props.style} className={'breadCrumbsItems'}>
            {props.routes ? props.routes.map(item => {
                if (item.actual) {
                    return <div key={item.link + item.title} className={'breadRoute__actual'}>
                        {item.link
                            ? <Link to={item.link} replace>{item.title}</Link>
                            : <a style={{cursor: 'pointer'}} href={null}>{item.title}</a>
                        }
                    </div>
                }
                return <div key={item.link + item.title} className={'breadRoute'}>
                    {item.link ?
                        <Link to={item.link} replace>{item.title}</Link> :
                        <a style={{cursor: 'pointer'}} href={null}>{item.title}</a>
                    } <span>/</span></div>
            }) : ''}
        </div>
    );
}

export default BreadCrumbsItems;